export const getSearchTerms = ({ searchReducer: { search_terms } }) => search_terms;
